/* eslint-disable max-len */
/* eslint-disable */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';
import { RegularButton, SearchInput } from 'pg-ui-library';
import { SortOrder, TableColumn } from 'react-data-table-component';
import useDebounceSearchTerm from 'src/hooks/useDebounceSearchTerm';
import { DefaultTable } from 'src/components';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left-black.svg';
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';
import { Select, MenuItem, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@mui/material';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import {
  ArrowBack,
  ColumnTitle,
  Container,
  Header,
  HeaderItems,
  NavTextLink,
  ReportsContainer,
  SearchStyle,
} from './styles';

const columns: TableColumn<any>[] = [
  {
    name: <ColumnTitle>Benefit Id</ColumnTitle>,
    selector: (row: any) => row.benefitId || '',
    sortable: true,
    sortField: 'benefitId',
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Employee Name</ColumnTitle>,
    selector: (row: any) => `${row.firstName} ${row.lastName}` || '',
    sortable: false,
    reorder: true,
    width: '160px',
  },
  // {
  //   name: <ColumnTitle>SSN</ColumnTitle>,
  //   selector: (row: any) => row.ssn || '',
  //   sortable: false,
  //   reorder: true,
  //   width: '160px',
  // },
  {
    name: <ColumnTitle>Hire Date</ColumnTitle>,
    selector: (row: any) => row.hireDate || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  // {
  //   name: <ColumnTitle>Birth Date</ColumnTitle>,
  //   selector: (row: any) => row.birthDate || '',
  //   sortable: false,
  //   reorder: true,
  //   width: '130px',
  // },
  {
    name: <ColumnTitle>Birth Date</ColumnTitle>,
    selector: (row: any) => {
      if (!row.birthDate) return '';
      const dateStr = String(row.birthDate);
      if (dateStr.length >= 4) {
        return `${dateStr.slice(0, -4)}****`;
      }
      return dateStr;
    },
    width: '180px',
    sortField: 'birthDate',
    omit: false,
    sortable: true,
    reorder: true,
  },
  {
    name: <ColumnTitle>Agreement</ColumnTitle>,
    selector: (row: any) => row.agreementTermId || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Active/Inactive</ColumnTitle>,
    selector: (row: any) => row.terminationDate || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Worker Type</ColumnTitle>,
    selector: (row: any) => row.workerType || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Gender</ColumnTitle>,
    selector: (row: any) => row.gender || '',
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Cost</ColumnTitle>,
    selector: (row: any) => (row.cost !== undefined && row.cost !== null ? row.cost : '0'),
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Annual</ColumnTitle>,
    selector: (row: any) => (row.annual !== undefined && row.annual !== null ? row.annual : '0'),
    sortable: false,
    reorder: true,
    width: '130px',
  },
  {
    name: <ColumnTitle>Pre-Tax/Post-Tax</ColumnTitle>,
    selector: (row: any) => row.postAndPreTax || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Pay Rate</ColumnTitle>,
    selector: (row: any) => row.payRate || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Annual Equivalent</ColumnTitle>,
    selector: (row: any) => row.annualEquivalent || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Position Type</ColumnTitle>,
    selector: (row: any) => row.positionType || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Plan Name</ColumnTitle>,
    selector: (row: any) => row.planName || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Plan Description</ColumnTitle>,
    selector: (row: any) => row.planDescription || '',
    sortable: false,
    reorder: true,
    width: '180px',
  },
  {
    name: <ColumnTitle>Submission Date</ColumnTitle>,
    selector: (row: any) => row.submissionDate || '',
    sortable: false,
    reorder: true,
    width: '180px',
  },
  {
    name: <ColumnTitle>Event Type</ColumnTitle>,
    selector: (row: any) => row.eventType || '',
    sortable: false,
    reorder: true,
  },
  {
    name: <ColumnTitle>Worker Id</ColumnTitle>,
    selector: (row: any) => row.workerId || '',
    sortable: true,
    sortField: 'workerId',
    reorder: true,
  },
  {
    name: <ColumnTitle>Enrollment Start</ColumnTitle>,
    selector: (row: any) => row.enrollmentStart || '',
    sortable: true,
    sortField: 'enrollmentStart',
    reorder: true,
    width: '180px',
  },
  {
    name: <ColumnTitle>Enrollment End</ColumnTitle>,
    selector: (row: any) => row.enrollmentEnd || '',
    sortable: true,
    sortField: 'enrollmentEnd',
    reorder: true,
    width: '180px',
  },
  {
    name: <ColumnTitle>Calculate Rate</ColumnTitle>,
    selector: (row: any) => row.calculateRate || '',
    sortable: true,
    sortField: 'calculateRate',
    reorder: true,
  },
  // {
  //   name: <ColumnTitle>Amount or Rate Contribution</ColumnTitle>,
  //   selector: (row: any) => row.amountOrRateContribution || '',
  //   sortable: true,
  //   sortField: 'amountOrRateContribution',
  //   reorder: true,
  // },
  {
    name: <ColumnTitle>Basis Deduction</ColumnTitle>,
    selector: (row: any) => row.basisContributions || '',
    sortable: true,
    sortField: 'basisDeduction',
    reorder: true,
  },
  // {
  //   name: <ColumnTitle>Basis Contributions</ColumnTitle>,
  //   selector: (row: any) => row.basisContributions || '',
  //   sortable: true,
  //   sortField: 'basisContributions',
  //   reorder: true,
  // },
  {
    name: <ColumnTitle>Amount or Rate Deduction</ColumnTitle>,
    selector: (row: any) => row.amountOrRateDeduction || '',
    sortable: true,
    sortField: 'amountOrRateDeduction',
    reorder: true,
  },
  {
    name: <ColumnTitle>Effect</ColumnTitle>,
    selector: (row: any) => row.effective || '',
    sortable: true,
    sortField: 'effective',
    reorder: true,
  },
  {
    name: <ColumnTitle>Expiration</ColumnTitle>,
    selector: (row: any) => row.expiration || '',
    sortable: true,
    sortField: 'expiration',
    reorder: true,
  },
  {
    name: <ColumnTitle>Employee Class</ColumnTitle>,
    selector: (row: any) => row.employeeClass || '',
    sortable: true,
    sortField: 'employeeClass',
    reorder: true,
  },
  {
    name: <ColumnTitle>Smoker</ColumnTitle>,
    selector: (row: any) => row.smoker || '',
    sortable: true,
    sortField: 'smoker',
    reorder: true,
  },
  {
    name: <ColumnTitle>Coverage Amount</ColumnTitle>,
    selector: (row: any) => row.coverageAmount || '',
    sortable: true,
    sortField: 'coverageAmount',
    reorder: true,
  },
  {
    name: <ColumnTitle>Dependent First Name</ColumnTitle>,
    selector: (row: any) => row.dependentFirstName || '',
    sortable: true,
    sortField: 'dependentFirstName',
    reorder: true,
    width: '200px',
  },
  {
    name: <ColumnTitle>Date of Birth</ColumnTitle>,
    selector: (row: any) => {
      if (!row.dependentBirthDate) return '';
      const dateStr = String(row.dependentBirthDate);
      if (dateStr.length >= 4) {
        return `${dateStr.slice(0, -4)}****`;
      }
      return dateStr;
    },
    width: '180px',
    sortField: 'dependentBirthDate',
    omit: false,
    sortable: true,
    reorder: true,
  },
  // {
  //   name: <ColumnTitle>Dependent SSN</ColumnTitle>,
  //   selector: (row: any) => <div title={row.dependentSSN || ''}>{row.dependentSSN || ''}</div>,
  //   sortable: true,
  //   sortField: 'dependentSSN',
  //   reorder: true,
  //   width: '320px',
  // },
  {
    name: <ColumnTitle>Beneficiary First Name</ColumnTitle>,
    selector: (row: any) => row.beneficiaryFirstName || '',
    sortable: true,
    sortField: 'dependentFirstName',
    reorder: true,
    width: '200px',
  },
  {
    name: <ColumnTitle>Beneficiary Date of Birth</ColumnTitle>,
    selector: (row: any) => row.beneficiaryBirthDate || '',
    sortable: true,
    sortField: 'dependentBirthDate',
    reorder: true,
    width: '370px',
  },
  // {
  //   name: <ColumnTitle>Beneficiary SSN</ColumnTitle>,
  //   selector: (row: any) => row.beneficiarySSN || '',
  //   sortable: true,
  //   sortField: 'dependentSSN',
  //   reorder: true,
  //   width: '320px',
  // },
  {
    name: <ColumnTitle>Beneficiary Percentage</ColumnTitle>,
    selector: (row: any) => row.percentage || '',
    sortable: true,
    sortField: 'percentage',
    reorder: true,
  },
  // {
  //   name: <ColumnTitle>Address</ColumnTitle>,
  //   selector: (row: any) => <div title={row.address || ''}>{row.address || ''}</div>,
  //   sortable: true,
  //   sortField: 'dependentSSN',
  //   reorder: true,
  //   width: '600px',
  // },
];

export const WorkerEnrolledBenefits: React.FC = () => {
  const { searchTerm, setSearchTerm } = useDebounceSearchTerm(500);
  const { t } = useTranslation();
  const { data: companies } = useTypedSelector(state => state.companies);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [eventType, setEventType] = useState('');
  // const [startDate, setStartDate] = useState('');
  // const [endDate, setEndDate] = useState('');
  const [employeeClass, setEmployeeClass] = useState('');

  const [hasDatesInitialized, setHasDatesInitialized] = useState(false);

  const companyIdFromStore = useTypedSelector(state => state.config.data?.config?.selectedCompanyId) || '';
  const [isFilterApplied, setIsFilterApplied] = useState(false);

  // Define functions for calculating date limits

  const getTodayFormatted = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const [startDate, setStartDate] = useState(`${currentYear}-01-01`);
  const [endDate, setEndDate] = useState(getTodayFormatted());
  const [isDatesSet, setIsDatesSet] = useState(true);

  const calculateMaxEndDate = (start: string): string => {
    if (!start) return '';

    const s = new Date(`${start}T00:00:00`);
    s.setFullYear(s.getFullYear() + 1);
    s.setDate(s.getDate() - 1);

    return s.toLocaleDateString('en-CA'); // YYYY-MM-DD
  };

  const calculateMinStartDate = (end: string): string => {
    if (!end) return '';

    const e = new Date(`${end}T00:00:00`);
    e.setFullYear(e.getFullYear() - 1);
    e.setDate(e.getDate() + 1);

    return e.toLocaleDateString('en-CA'); // YYYY-MM-DD
  };

  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const handlePreviousYear = () => {
    const previousYear = selectedYear - 1;

    setSelectedYear(previousYear);
    setStartDate(`${previousYear}-01-01`);
    setEndDate(`${previousYear}-12-31`);
    setPage(1);
  };

  const handleNextYear = () => {
    if (selectedYear >= currentYear) return;

    const nextYear = selectedYear + 1;

    setSelectedYear(nextYear);
    setStartDate(`${nextYear}-01-01`);

    setEndDate(nextYear === currentYear ? getTodayFormatted() : `${nextYear}-12-31`);

    setPage(1);
  };

  const [isReady, setIsReady] = useState(false);

  // Function to calculate 90 days before a date
  const calculateStartDate = (date: string) => {
    const end = new Date(date);
    end.setDate(end.getDate() - 90);
    return end.toISOString().split('T')[0];
  };

  // Set initial dates
  // useEffect(() => {
  //   const today = new Date();
  //   const todayFormatted = today.toISOString().split('T')[0];
  //   setEndDate(todayFormatted); // Set today's date as the endDate

  //   const startFormatted = calculateStartDate(todayFormatted); // Calculate startDate
  //   setStartDate(startFormatted); // Set the startDate 90 days before the endDate

  //   setIsDatesSet(true); // Now the dates are set
  // }, []);

  // Function to calculate the difference in days between two dates
  const diffInDays = (date1: string, date2: string) =>
    (new Date(date2).getTime() - new Date(date1).getTime()) / (1000 * 60 * 60 * 24);

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStart = e.target.value;

    if (newStart && endDate && newStart > endDate) {
      return;
    }

    setStartDate(newStart);
    setIsFilterApplied(true);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEnd = e.target.value;

    if (newEnd && startDate && newEnd < startDate) {
      return;
    }

    setEndDate(newEnd);
    setIsFilterApplied(true);
  };

  const {
    data: benefitsItems,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(
    [
      'benefits',
      { startDate, endDate, page, companyId, limit, searchTerm, sortBy, sortDirection, eventType, employeeClass },
    ],
    () => {
      console.log('API Call Params:', {
        startDate,
        endDate,
        page,
        companyId,
        limit,
        searchTerm,
        sortBy,
        sortDirection,
        eventType,
        employeeClass,
      });
      return BenefitsService.getWorkerEnrolledBenefits({
        startDate,
        endDate,
        page,
        companyId,
        limit,
        search: searchTerm,
        sortBy,
        sortDirection,
        eventType,
        employeeClass,
      });
    },
    {
      enabled: isDatesSet && startDate !== '' && endDate !== '',
      keepPreviousData: true,
    }
  );

  const exportToExcel = () =>
    BenefitsService.getWorkerEnrolledBenefitsXLSLink(
      eventType,
      startDate,
      endDate,
      companyId,
      searchTerm,
      employeeClass
    );

  const handlePageChange = (nPage: number) => {
    setPage(nPage);
  };

  const handlePerRowsChange = async (newLimit: number, nPage: number) => {
    setPage(nPage);
    setLimit(newLimit);
  };

  const handleSort = async (column: TableColumn<any>, newSortDirection: SortOrder) => {
    setSortBy(column.sortField as unknown as string);
    setSortDirection(newSortDirection);
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setCompanyId('');
    setEventType('');
    setEmployeeClass('');
    setSelectedYear(currentYear);
    setStartDate(`${currentYear}-01-01`);
    setEndDate(getTodayFormatted());
    setPage(1);
    setIsFilterApplied(false);
  };

  return (
    <Container>
      <Header>
        <HeaderItems>
          <NavTextLink to="/reports">
            <div style={{ marginTop: '22px' }}>
              <ArrowBack src={Arrow} />
            </div>
          </NavTextLink>
          {/* Filters moved outside the dialog and placed here */}
          <Box display="flex" alignItems="center" gap={1}>
            <SearchStyle style={{ marginTop: '22px' }}>
              <SearchInput
                value={searchTerm}
                placeholder="Search..."
                handleChange={event => {
                  const value = event.target.value;
                  setSearchTerm(value);
                  setIsFilterApplied(!!value.trim());
                }}
              />
            </SearchStyle>
            <Box sx={{ width: '140px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>Event Type</p>
              <Select
                value={eventType}
                onChange={e => {
                  setEventType(e.target.value);
                  setIsFilterApplied(true);
                }}
                displayEmpty
                sx={{
                  height: '40px',
                  fontSize: '16px',
                  padding: '5px',
                  '& .MuiSelect-select': {
                    padding: '10px',
                    minWidth: '90px',
                  },
                }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="new_hire">New Hire</MenuItem>
                <MenuItem value="open_enrollment">Open Enrollment</MenuItem>
                <MenuItem value="qle">Qualifying Life Event</MenuItem>
              </Select>
            </Box>
            <Box sx={{ width: '250px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>Company</p>

              <Select
                value={companyId}
                onChange={e => {
                  const selectedCompanyId = e.target.value;
                  const selectedCompany = companies?.companies?.find(company => company.id === selectedCompanyId);

                  if (selectedCompany) {
                    setEmployeeClass(selectedCompany.legalEntityId);
                  } else {
                    setEmployeeClass('');
                  }

                  setCompanyId(selectedCompanyId);
                  setIsFilterApplied(true);
                }}
                displayEmpty
                sx={{
                  height: '40px',
                  fontSize: '16px',
                  padding: '10px',
                  '& .MuiSelect-select': {
                    padding: '10px',
                    minWidth: '200px',
                  },
                }}
              >
                <MenuItem value="">All</MenuItem>
                {companies?.companies?.map(company => (
                  <MenuItem key={company.id} value={company.id}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Box display="flex" alignItems="center" gap={1} sx={{ marginTop: '22px' }}>
              <RegularButton onClick={handlePreviousYear}>←</RegularButton>
            </Box>

            <Box sx={{ width: '120px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>Start Date</p>

              <TextField
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                inputProps={{
                  style: { fontSize: 14, padding: '10px' },
                  max: endDate || undefined,
                }}
                fullWidth
                sx={{ maxWidth: '120px' }}
              />
            </Box>
            <Box sx={{ width: '120px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '5px' }}>End Date</p>

              <TextField
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                inputProps={{
                  style: { fontSize: 14, padding: '10px' },
                  min: startDate || undefined,
                  max: getTodayFormatted(),
                }}
                fullWidth
                sx={{ maxWidth: '120px' }}
              />
            </Box>
          </Box>

          <Box display="flex" alignItems="center" gap={1} sx={{ marginTop: '22px' }}>
            <RegularButton onClick={handleNextYear} disabled={selectedYear >= currentYear}>
              →
            </RegularButton>
          </Box>

          {isFilterApplied && (
            <RegularButton onClick={handleClearFilters} style={{ margin: '4px', marginTop: '22px' }}>
              Clear Filters
            </RegularButton>
          )}

          <a href={exportToExcel()} download rel="noreferrer">
            <RegularButton style={{ margin: '4px', marginTop: '22px' }}>{t('global.form.exportExcel')}</RegularButton>
          </a>
        </HeaderItems>
      </Header>

      <ReportsContainer>
        <DefaultTable
          columns={columns}
          data={benefitsItems?.items || []}
          progressPending={isLoading || isFetching}
          pagination
          paginationServer
          paginationTotalRows={benefitsItems?.meta.totalItems || 0}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          onSort={handleSort}
          sortServer
        />
      </ReportsContainer>
    </Container>
  );
};
